module.exports = __webpack_public_path__ + "img/team-list2.1db6f032.png";